import React, { Component } from 'react'
import { Link, browserHistory } from 'react-router'
import Navigation from './navigation'

import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

export default class Header extends Component {

   constructor(props) {
    super(props)

    this.state = {
      sideBarOpen: false
    }

    this.toggleSidebar = this.toggleSidebar.bind(this)

    browserHistory.listen( location =>  {
     this.setState({
      sideBarOpen: false
     })
     document.body.setAttribute('data-sidebar-open', false)
    })
  }

  toggleSidebar() {
    const { sideBarOpen } = this.state

    this.setState({
      sideBarOpen: !sideBarOpen
    })

    document.body.setAttribute('data-sidebar-open', !sideBarOpen)
  }

  render() {
    const { sideBarOpen } = this.state

    return (
      <ReactCSSTransitionGroup
        transitionName="page"
        transitionAppear={true}
        transitionAppearTimeout={750}
        transitionEnterTimeout={750}
        transitionLeaveTimeout={750}
        component="header"
      >

        <Link to={'/'}>
        <h1 className="title">aSocial ☻</h1>
        </Link>
        <Navigation {...this.props} />
        <button className="sidebar-button" onClick={this.toggleSidebar}> {sideBarOpen ? '✘' : '☰'} </button>
      </ReactCSSTransitionGroup>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/header.js